import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

export const StyledCard = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: COLORS.white,
    height: '302px',
    maxWidth: '196px',
    minWidth: '175px',
    borderRadius: '20px',
    padding: '24px 20px',
    boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.05)',
    position: 'relative',
    flex: 1,
  };
});

export const StyledImage = styled('img')(() => {
  return {
    position: 'absolute',
    top: 24,
    left: '50%',
    height: '40px',
    width: '40px',
    transform: 'translateX(-50%)',
  };
});

export const StyledNumber = styled('div')(() => {
  return {
    position: 'absolute',
    top: 28,
    left: '50%',
    transform: 'translateX(-50%)',
  };
});

export const StyledText = styled('div')(() => {
  return {
    position: 'absolute',
    top: '80px',
    left: '20px',
    right: '20px',
  };
});

export const StyledTopArrow = styled('img')(() => {
  return {
    position: 'absolute',
    top: -11,
    left: 148,
    height: '28px',
    width: '90px',
    zIndex: 1,
  };
});

export const StyledBottomArrow = styled('img')(() => {
  return {
    position: 'absolute',
    bottom: -11,
    left: 148,
    height: '28px',
    width: '90px',
    zIndex: 1,
  };
});
